import sessionApi, { SessionValidationResponse } from '~/clientApis/sessionApi';

const checkSessionValidity = async (): Promise<SessionValidationResponse> => {
    try {
        const response = await sessionApi.validateSession();
        return response;
    } catch (error) {
        return {
            valid: false,
            reason: 'request_failed',
        };
    }
};

export default checkSessionValidity;
